import { useMemo } from 'react';
import styled from '@emotion/styled';
import { Alert, Spin } from 'antd';
import ExtraNode from 'views/Dashboard/ImplementData/components/Filter/ExtraNode';
import { last7days, ctx2FetchParam } from 'views/Dashboard/ImplementData/utils';
import FilterProvider from 'views/Dashboard/ImplementData/components/Filter/Provider';
import { useAsync } from 'react-use';
import { useDashboardFilter } from 'views/Dashboard/ImplementData/components/Filter/useFilter';
import { getRobotContributionOverview } from 'services/api/dashboard';

import Banner from './Banner';
import Reception from './Reception';
import RobotContribution from './RobotContribution';
import { useTranslate } from '@tolgee/react';
import { useOrgConfigQAEnable } from 'hooks/business/useOrgConfig';

const Container = styled.div`
  margin-bottom: 16px;
`;
interface Props {}

export const initialValue = {
  storeInfo: {},
  dateRange: last7days(),
} as const;

const Content = () => {
  const qaEnable = useOrgConfigQAEnable();
  const filterCtx = useDashboardFilter();
  const fetchParams = useMemo(() => {
    return {
      ...ctx2FetchParam(filterCtx),
      qaIs: qaEnable,
    };
  }, [filterCtx, qaEnable]);
  const { value } = useAsync(() => getRobotContributionOverview(fetchParams), [fetchParams]);
  return (
    <Spin spinning={false}>
      <Container>
        <Banner value={value} />
        {qaEnable ? <Reception /> : null}
        <RobotContribution />
      </Container>
    </Spin>
  );
};

const Robot = (props: Props) => {
  const { t } = useTranslate();
  return (
    <FilterProvider
      initialValue={initialValue}
      rightExtra={ExtraNode}
      dashboardName="PerformanceRobot"
      scene="ASSISTANT_PERFORMANCE"
      showPlatformAll
    >
      <Alert
        type="warning"
        showIcon
        message={t(
          '「机器人贡献」数据板块已升级为「AI问答」并在数据中心单独展示，7月将下线本板块，请前往「AI问答」查看机器人数据',
        )}
      />
      <Content />
    </FilterProvider>
  );
};

export default Robot;
